import {
  JoinToClassroom,
  useNavigation,
  useUser,
} from '@innovamat/ga-features';
import { useSearchParams } from 'react-router-dom';
import { Logo } from '../components/logo';
import { Header } from '../layout/header';

const NAVIGATION_PARAM_IS_JOURNEY_TYPE = 'j';

export function JoinToClassroomPage(): JSX.Element {
  const { user } = useUser();
  const [params] = useSearchParams();

  const { goToHome, goBackOrHome } = useNavigation();

  const isFirstTime = !!params.get('ft');
  const isJourney = params.get('ty') === NAVIGATION_PARAM_IS_JOURNEY_TYPE;

  return (
    <>
      <Header leftActions={<Logo />} />

      {user && (
        <JoinToClassroom
          orgId={user.organizationId}
          region={user.region}
          email={user.email}
          onGoBack={goBackOrHome}
          onGoHome={goToHome}
          isFirstTime={isFirstTime}
          isJourney={isJourney}
        />
      )}
    </>
  );
}
